import { render, staticRenderFns } from "./AttributeValueEditor.vue?vue&type=template&id=46ec8b79&scoped=true"
import script from "./AttributeValueEditor.vue?vue&type=script&lang=js"
export * from "./AttributeValueEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ec8b79",
  null
  
)

export default component.exports